import { Component } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation, A11y, Pagination, Mousewheel } from 'swiper'
import classNames from 'classnames'
import {JSONFetcher, MatchingFundHelper, GtmHelper, formatCents, findApiV4Link, gaEvent} from 'shared'

SwiperCore.use([Navigation, A11y, Pagination, Mousewheel])

export class NeedList extends Component {
  constructor(props) {
    super(props)
    this.state = { data: [], project: null }
  }

  componentDidMount() {
    JSONFetcher.load({
      url:     this.props.apiUrl,
      success: (response) => { this.setState(response) }
    })
    JSONFetcher.load({
      url:     this.props.projectApiUrl,
      success: (project) => { this.setState({ project: project })}
    })
  }

  // Hide pagination buttons if all entries are visible.
  get btnGroupClass() {
    return (this.state.total_entries <= 3) ? ' d-md-none' : 'd-md-block'
  }

  render() {
    // Hide component if nothing is loaded yet or no needs are present
    if (!this.state.total_entries) return null
    let content = this.state.data.map(
      need => {
        return (
          <SwiperSlide key={need.id}>
            <Need project={this.state.project} {...need} />
          </SwiperSlide>
        )
      }
    )

    return (
      <div>
        <h2 className='text-3xl'>
          {I18n.t('projects.show.needs.headline')} ({this.state.total_entries})
          <div className={'btn-group btn-group-with-small-arrows d-none ' + this.btnGroupClass}>
            <a id='need-list-prev' className='btn btn-secondary'>
              <i className='fa fa-caret-left'></i>
            </a>
            <a id='need-list-next' className='btn btn-secondary'>
              <i className='fa fa-caret-right'></i>
            </a>
          </div>
        </h2>
        <Swiper
          spaceBetween={40}
          slidesPerView={1}
          pagination={{
            clickable: true,
            dynamicBullets: true,
          }}
          navigation={{
            nextEl: '#need-list-next',
            prevEl: '#need-list-prev',
            disabledClass: 'is-disabled',
          }}
          centeredSlides={this.state.total_entries == 1}
          roundLengths={true}
          mousewheel={{ forceToAxis: true }}
          breakpoints={{
            420: {
              slidesPerView: 3,
            },
          }}
        >
          {content}
        </Swiper>
      </div>
    )
  }
}

class Need extends Component {

  get donateUrl() {
    if (this.props.project && this.props.project.donations_prohibited) return undefined
    return findApiV4Link({ ofObject: this.props, withRel: 'new_donation' })
  }

  get matchingFundCheck() {
    return !!MatchingFundHelper.locallyActiveMatchingFund(this.props.project)
  }

  tracking = (event) => {
    this.props.project && GtmHelper.pushAddToBasket(this.props.project)

    if (event.target.classList.contains('btn')) {
      gaEvent('donation', 'click need_donation_button', this.props.title)
    } else {
      gaEvent('donation', 'click need_donation_container', this.props.title)
    }
  }

  render() {
    let teaserClass = classNames('need-teaser', 'swiper-slide', {
      'need-teaser-disabled': this.props.project && this.props.project.donations_prohibited,
    })

    return <a href={ this.donateUrl } className={teaserClass} onClick={ this.tracking }>
      <div className='text-lg' dangerouslySetInnerHTML={{ __html: this.props.title }}></div>
      <div className='need-teaser-amount'>
        {formatCents(this.props.open_amount_in_cents, {precision: 0}) }&nbsp;
        { I18n.t('projects.show.needs.still_missing_label') }&nbsp;
        { formatCents(this.props.requested_amount_in_cents, {precision: 0})}
      </div>
      <div className='need-teaser-description' dangerouslySetInnerHTML={{ __html: this.props.description }}></div>
      <DonateButton duplicationIcon={this.matchingFundCheck} />
      <div className='progress generic-progress-bar'>
        <div className='bar' style={{ width: `${this.props.progress_percentage}%` }}></div>
      </div>
    </a>
  }
}

class DonateButton extends Component {
  render() {
    let btnClass = classNames('btn', 'btn-primary', 'btn-large',
      'no-pseudo-hover-styles', { 'duplication-icon': this.props.duplicationIcon })

    return <span className={btnClass}>{ I18n.t('projects.show.needs.donate_button_label') }</span>
  }
}
